import { CSSProperties, FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
   styles?: CSSProperties;
}

export const TableHead: FC<Props> = ({ styles, children }) => (
   <thead data-testid="table-head" style={styles}>
      {children}
   </thead>
);
